import { Flex } from "@mantine/core";
import React from "react";
import { Link } from "react-router-dom";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import RedditIcon from "@mui/icons-material/Reddit";
import EmailIcon from "@mui/icons-material/Email";

export default function Footer() {
  return (
    <div className="footer-wrapper">
      <hr />
      <br />
      <Flex align="end" gap="5rem" justify="center">
        <Flex gap="5rem" justify="space-between">
          <div>
            <h2>About Buck</h2>
            <Link to={"info/about"}>About the project</Link>
            <br />
            <Link to={"info/credits"}>Credits and tools used</Link>
            <br />
            <Link to={"/auth/terms-and-conditions"}>Terms and conditions</Link>
          </div>
          <div>
            <h2>How to use</h2>
            {/* all this should be on the same page but when 
          the user clicks on one of them it should open to that
          section of the page
          */}
            <p>Placing orders</p>
            <p>Selling products</p>
            <p>Manage account</p>
          </div>
          <div>
            {/* all with specific app icons */}
            <h2>Contact</h2>
            <Link to="https://www.reddit.com/user/R-A-Z-V-A-N_47">
              <Flex gap={3} align={"center"}>
                <RedditIcon />
                <p>u/R-A-Z-V-A-N_47</p>
              </Flex>
            </Link>

            <Link to="https://mail.google.com/mail/u/0/#inbox?compose=CllgCJZZzSblLjWtRlxhBMsZJmTjtxcgGXcJMRBHsMRWScCcRngwhHzNpLGMcwxJtXMpLxWlmzL&projector=1">
              <Flex gap={3} align={"center"}>
                <EmailIcon />
                <p>trif.razvan.sebastian@gmail.com</p>
              </Flex>
            </Link>

            <Link to="https://www.linkedin.com/in/razvan-trif-b1115a268/">
              <Flex gap={3} align={"center"}>
                <LinkedInIcon />
                <p>Razvan Trif</p>
              </Flex>
            </Link>
          </div>
          {/* <div>
            <h2>Other projects</h2>
            <p>gitlab link</p>
            <p>admin tab</p>
            <p>other project</p>
          </div> */}
        </Flex>
        <div
          style={{
            textAlign: "right",
          }}
        >
          <h2>V 1.1.3</h2>
          <p>made by Trif Razvan</p>
        </div>
      </Flex>
    </div>
  );
}
